import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Alert from '../../container/Alert';
import Comfirm from '../../container/Comfirm';
import Footer from '../Footer';
import { push } from 'connected-react-router';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'approve.page.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Approval'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class Approve extends Component {
  componentWillMount() {
    console.log(this.props.memberusername);
    // if(this.props.isAuthenticated && this.props.status.payload.data.role!='ACCOUNT_APPROVER'){
    //   push('/en_CA/404');
    //   return;
    // }
    this.props.getuser(this.props.memberusername);
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />

        <Alert
          title="Approve Account Error"
          body="Invalid Username"
          message={print(this.props.status)}
        />
        <Comfirm
          pagetitle={this.props.intl.formatMessage(messages.htmlHeader)}
          message={print(this.props.status)}
          nextpage="approvemsg"
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm
              className="form"
              onSubmit={({ memberrole }) => this.props.approveSubmitHandler(memberrole)}
            >
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="edit-project.form.name"
                    defaultMessage="Name: "
                  />
                </label>
                <Control.text
                  model=".name"
                  value={this.props.membername}
                  disabled
                  autoFocus
                  required
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="login.signup.username"
                    defaultMessage="User Name: "
                  />
                </label>
                <Control.text
                  model=".username"
                  value={this.props.memberusername}
                  disabled
                  autoFocus
                  required
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="assessment.request.translation.Email.name"
                    defaultMessage="Email: "
                  />
                </label>

                <Control.text
                  model=".email"
                  value={this.props.memberemail}
                  disabled
                  autoFocus
                  required
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="telephone.label.name"
                    defaultMessage="Telephone"
                  />
                </label>

                <Control.text
                  model=".membertelephone"
                  value={this.props.membertelephone}
                  disabled
                  autoFocus
                  required
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="projects.user.role"
                    defaultMessage="Role: "
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                <Control.select
                  model=".memberrole"
                 defaultValue={this.props.memberrole}
                 //defaultValue="SALESMAN_ENGINEER"
                  autoFocus
                  required
                // onChange={({ role }) =>this.props.selectroleHandler(role)}
                //onChange= {this.props.selectrole}
                 disabled={this.props.memberstatus == 'APPROVED'}
                >
                  <option value="">Please select one role</option>
                  {/* <option value="SALESMAN_ENGINEER">Sales Engineer</option>
                  <option value="PROFESSIONAL_SERVICE">Professional Service Engineer</option> */}
                  <option value="DATA_ENGINEER">
                    Commercial code translation engineer
                  </option>
                </Control.select>
              </fieldset>

              <div className="button-container" style={{ textAlign: 'center1' }}>
                <button
                  className="button"
                  type="submit"
                  //onClick={({ memberrole }) => this.props.approveSubmitHandler(memberrole)}
                  style={{ marginRight: '30px' }}
                  disabled={this.props.memberstatus == 'APPROVED'}
                >
                  <FormattedMessage
                    id="approve.button.name"
                    textTransform="capitalize"
                    defaultMessage="Approve"
                  />
                </button>

                <button
                  className="button"
                  type="button"
                  disabled={this.props.memberstatus == 'APPROVED'}
                  style={{ marginRight: '30px' }}
                  onClick={() => this.props.approveRejectHandler()}
                  disabled={this.props.memberstatus === 'APPROVED'}
                >
                  <FormattedMessage
                    id="reject.button.name"
                    defaultMessage="Reject"
                  />
                </button>

                <button
                  className="button"
                  type="button"
                  style={{ marginRight: '100px' }}
                  onClick={() => this.props.sendfinalapproveHandler()}
                  disabled={this.props.memberstatus === 'APPROVED'}
                >
                  <FormattedMessage
                    id="submittofinal.button.name"
                    defaultMessage="Submit to account aprrover"
                  />
                </button>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

Approve.propTypes = {
  getuser: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(Approve);



// WEBPACK FOOTER //
// ./src/components/views/ApproveData/index.js